// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__xNMGU","Logo":"SideDrawer_Logo__19OHL","Open":"SideDrawer_Open__x-od4","Close":"SideDrawer_Close__nVcym"};